import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, ChevronDownIcon, BrainIcon, WrenchIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
const stages = [{
  num: '1',
  icon: BrainIcon,
  title: 'Bienvenida y Base Mental',
  subtitle: 'Lo que nadie te dice antes de arrancar',
  desc: 'Entendé el negocio en crudo antes de tocar una herramienta. La mentalidad correcta separa a los que ejecutan de los que procrastinan.',
  bullets: ['Cómo funciona este negocio de verdad', 'Qué esperar en las primeras semanas', 'Mentalidad de ejecución inmediata']
}, {
  num: '2',
  icon: WrenchIcon,
  title: 'Ecosistema Técnico',
  subtitle: 'Tu negocio armado paso a paso',
  desc: 'Shopify, pasarela de pagos, Meta Business Suite, Pixel y tu primera landing. Sin conocimientos previos.',
  bullets: ['Shopify configurado desde cero', 'Pasarela de pagos activa', 'Meta Business Suite conectado', 'Pixel instalado correctamente', 'Primera landing funcionando']
}, {
  num: '3',
  icon: TargetIcon,
  title: 'Tus Primeros Anuncios',
  subtitle: 'De cuenta nueva a testeo activo',
  desc: 'Calentamiento de cuenta nueva y tu primera metodología de testeo con criterio. Sin quemar presupuesto.',
  bullets: ['Calentamiento de cuenta paso a paso', 'Metodología de testeo estructurada', 'Cómo leer tus primeros resultados']
}, {
  num: '4',
  icon: TrendingUpIcon,
  title: 'Cierre y Próximos Pasos',
  subtitle: 'Tu negocio lanzado, ¿y ahora qué?',
  desc: 'Qué métricas mirar, cómo interpretar resultados y cuál es el paso siguiente para escalar.',
  bullets: ['Cómo leer tus primeras métricas', 'Qué optimizar primero', 'El camino al siguiente nivel']
}];
export function Stages() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="py-12 md:py-20 bg-dark-900 border-t border-white/5 relative" data-id="element-218">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-219">
        <div className="text-center mb-8 md:mb-12" data-id="element-220">
          <h2 className="text-gold-500 font-display text-base md:text-2xl tracking-widest uppercase mb-2 md:mb-3" data-id="element-221">
            Contenido Completo
          </h2>
          <p className="text-3xl md:text-6xl font-display text-white uppercase tracking-wide" data-id="element-222">
            Las 4 Etapas
          </p>
          <p className="text-sm md:text-xl text-gray-400 mt-2" data-id="element-223">
            Tu hoja de ruta para tener el negocio listo y vendiendo
          </p>
        </div>

        {/* Mobile: accordion */}
        <div className="md:hidden space-y-2.5" data-id="element-224">
          {stages.map((stage, i) => {
          const isOpen = openIndex === i;
          const Icon = stage.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`bg-dark-800 rounded-xl border ${isOpen ? 'border-gold-500/50' : 'border-white/5'} overflow-hidden transition-colors`} data-id="element-225">
                <button onClick={() => setOpenIndex(isOpen ? -1 : i)} className="w-full flex items-center gap-3 p-3.5 text-left" data-id="element-226">
                  <div className={`relative shrink-0 w-11 h-11 rounded-lg flex items-center justify-center transition-colors ${isOpen ? 'bg-gold-500' : 'bg-dark-900 border border-gold-500/30'}`} data-id="element-227">
                    <Icon className={`w-5 h-5 ${isOpen ? 'text-black' : 'text-gold-500'}`} data-id="element-228" />
                    <span className={`absolute -top-1 -right-1 w-4 h-4 rounded-full text-[9px] font-bold flex items-center justify-center ${isOpen ? 'bg-black text-gold-500' : 'bg-gold-500 text-black'}`} data-id="element-229">
                      {stage.num}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-230">
                    <div className="text-gold-500 font-display text-[10px] tracking-widest uppercase" data-id="element-231">
                      Etapa {stage.num}
                    </div>
                    <h3 className="text-sm font-display text-white uppercase leading-tight" data-id="element-232">
                      {stage.title}
                    </h3>
                  </div>
                  <ChevronDownIcon size={16} className={`text-gold-500 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-233" />
                </button>

                <AnimatePresence initial={false} data-id="element-234">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-235">
                      <div className="px-3.5 pb-3.5" data-id="element-236">
                        <p className="text-gold-400 font-medium text-xs mb-2" data-id="element-237">
                          {stage.subtitle}
                        </p>
                        <p className="text-gray-400 text-xs leading-relaxed mb-3" data-id="element-238">
                          {stage.desc}
                        </p>
                        <ul className="space-y-1.5 bg-dark-900/60 rounded-lg p-2.5 border border-white/5" data-id="element-239">
                          {stage.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2 text-gray-300 text-xs" data-id="element-240">
                              <ArrowRightIcon className="text-gold-500 shrink-0 mt-0.5" size={12} data-id="element-241" />
                              <span data-id="element-242">{bullet}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Desktop: full cards */}
        <div className="hidden md:block space-y-6" data-id="element-243">
          {stages.map((stage, i) => {
          const Icon = stage.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="bg-dark-800 rounded-2xl p-8 border-gold-subtle relative overflow-hidden group hover:border-gold-500/40 transition-colors" data-id="element-244">
                <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-245" />

                <div className="flex flex-row gap-8 relative z-10" data-id="element-246">
                  <div className="w-1/3" data-id="element-247">
                    <div className="flex items-center gap-3 mb-3" data-id="element-248">
                      <div className="w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center border border-gold-500/30" data-id="element-249">
                        <Icon className="text-gold-500" size={24} data-id="element-250" />
                      </div>
                      <div data-id="element-251">
                        <div className="text-gold-500 font-display text-sm tracking-widest uppercase" data-id="element-252">
                          Etapa {stage.num}
                        </div>
                      </div>
                    </div>
                    <h3 className="text-2xl font-display text-white uppercase leading-tight mb-2" data-id="element-253">
                      {stage.title}
                    </h3>
                    <p className="text-gold-400 font-medium mb-3 text-sm" data-id="element-254">
                      {stage.subtitle}
                    </p>
                    <p className="text-gray-400 leading-relaxed text-sm" data-id="element-255">
                      {stage.desc}
                    </p>
                  </div>

                  <div className="w-2/3 bg-dark-900/50 rounded-xl p-5 border border-white/5" data-id="element-256">
                    <ul className="space-y-3" data-id="element-257">
                      {stage.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-3 text-gray-300" data-id="element-258">
                          <ArrowRightIcon className="text-gold-500 shrink-0 mt-1" size={16} data-id="element-259" />
                          <span className="font-medium" data-id="element-260">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}